import type { CompetitionSeasonScopesResponse as ApiCompetitionSeasonScopesResponse } from '@ballpeek/api/client'

import { apiClient } from '~/lib/api-client'

const competitionScopesClient = apiClient.api['competition-scopes']

type ApiCompetitionSeasonScope = ApiCompetitionSeasonScopesResponse['scopes'][number]

export type CompetitionSeasonScope = ApiCompetitionSeasonScope

export interface CompetitionSeasonScopesResponse {
  scopes: CompetitionSeasonScope[]
}

export async function listCompetitionScopes(): Promise<CompetitionSeasonScopesResponse> {
  const response = await competitionScopesClient.$get()
  if (!response.ok) {
    throw new Error(`Competition scopes request failed with status ${response.status}`)
  }
  return response.json()
}
